<template>
  <h3 class="mtitle-bg">
    <span class="mtitle-bg-txt">{{title || $route.meta.subTitle}}</span>
  </h3>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
.mtitle-bg{
  position: relative;
  height: 9.33vw;
  width: 100%;
  background: url('../../assets/image/sub-title-bg.png') no-repeat center center;
  background-size: 100% 100%;
  &-txt{
    position: absolute;
    left: 3.47vw;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    padding: 0 2.13vw;
    height:6.8vw;
    line-height: 6.8vw;
    text-align: center;
    font-size:4.27vw;
    font-weight:400;
    color:rgba(0,77,154,1);
    background: #fff;
  }
}
</style>
